// Imported, so the EaterAccounts chunk downloads once login or a phone's account screen is opened.
function eaterAuthWrapper() {
    return import(
    /* webpackChunkName: "EaterAccounts" */ "../components/EaterAuthWrapper").then((mod) => mod.default);
}
export function openEaterLogin() {
    return eaterAuthWrapper().then((wrapper) => wrapper.openLogin());
}
export function openEaterAccount() {
    return eaterAuthWrapper().then((wrapper) => wrapper.openAccount());
}
export function eaterLoginPaths() {
    const config = Skubacz.configuration;
    return {
        account: config.account_path,
        terms: config.terms_path,
        privacyPolicy: config.privacy_policy_path,
    };
}
export function goToEaterAccount() {
    location.assign(Skubacz.configuration.account_path);
}
